var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 30C22.3848 30 26.75 25.6348 26.75 20.25C26.75 14.8652 22.3848 10.5 17 10.5C11.6152 10.5 7.25 14.8652 7.25 20.25C7.25 25.6348 11.6152 30 17 30Z",
    stroke: "#2C3B60",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6372 10.8563C30.4991 10.6225 31.3879 10.5027 32.281 10.5C34.8668 10.5 37.3468 11.5272 39.1752 13.3557C41.0037 15.1842 42.031 17.6641 42.031 20.25C42.031 22.8359 41.0037 25.3158 39.1752 27.1443C37.3468 28.9728 34.8668 30 32.281 30",
    stroke: "#2C3B60",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 37.0126C5.0224 34.8461 7.04382 33.0779 9.39351 31.8573C11.7432 30.6366 14.3522 29.9994 17 29.9994C19.6478 29.9994 22.2568 30.6366 24.6065 31.8573C26.9562 33.0779 28.9776 34.8461 30.5 37.0126",
    stroke: "#2C3B60",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2812 30C34.9293 29.9984 37.5388 30.6348 39.8887 31.8555C42.2387 33.0761 44.2599 34.8451 45.7812 37.0125",
    stroke: "#2C3B60",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.d0894607fee11216be724c6eeb5eecd7.svg";
export { ForwardRef as ReactComponent };